import React, { useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";

export const Footer = ({ version, env }) => {
  // const devFakeVersion = version.split(".");
  // devFakeVersion[2] = parseInt(devFakeVersion[2]) + 1;
  const feedbackRef = useRef<HTMLAnchorElement | null>(null);
  useEffect(() => {
    const feedback = Sentry.getFeedback();
    return feedback?.attachTo(feedbackRef.current!, {});
  }, []);

  return (
    <div className="w-full mt-3 mx-auto text-center">
      <a
        ref={feedbackRef}
        className="mr-2 text-xs text-customerText opacity-55 cursor-pointer"
      >
        Feedback senden
      </a>
      <small className="text-gray-200 ">
        {version} {env}
      </small>
    </div>
  );
};
